<main id="main">
  <!-- ======= Breadcrumbs ======= -->
  <section class="login-page-section-top ">
    <div class="container">
      <div class="row">
        <div class="col-md-12 size-img back-img">
          <div class="effect-cover">
            <h3 class="txt-advert animated fadeInUp">TOURNAMENTS</h3>
            <p class="txt-advert-sub animated">Want to know where you stand in the tennis world? <br> Compete in more
              than 600 ranking tournaments and earn precious TPL points against the best. Get yourself smashing! </p>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let banner of webBannerImageList"
      class="swiper-slide zoom-effect-container banner-image-div web-view-banner">
      <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
        <div class="headings image-card">
          <img [src]="banner.banner_image_src" class="product-image" alt="web banner" />
          <div class="slider-inner-div">
            <div class="container">
              <div class="main-heading-banner">
                <div class="sldier-bottom-section">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let banner of mobileBannerImageList"
      class="swiper-slide zoom-effect-container banner-image-div mobile-view-banner">
      <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
        <div class="headings image-card">
          <img [src]="banner.banner_image_src" class="product-image" alt="mobile banner" />
          <div class="slider-inner-div">
            <div class="container">
              <div class="main-heading-banner">
                <div class="sldier-bottom-section"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile_version-backbutton">
      <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span> Tournaments </a>
    </div>
  </section>
  <!-- ======= Product Section ======= -->
  <section class="team Tournaments-list tournament-list-main">
    <div class=" container aos-init aos-animate" data-aos="fade-up">
      <div class="row">
        <div class="col-md-12 mainPageTitle">
          <div class="pageTitle">
            <h2>Tournaments</h2>
            <p>Check out all the upcoming, past and current tournaments</p>
          </div>
          <div class="tab-div">
            <ul class="tabList">
              <li>
                <button (click)="onTabChange({ index: 2 })" [ngClass]="{'active-btn': activeTab === 2}">
                  Upcoming
                </button>
              </li>
              <li>
                <button (click)="onTabChange({ index: 1 })" [ngClass]="{'active-btn': activeTab === 1}">
                  Live
                </button>
              </li>
              <li>
                <button (click)="onTabChange({ index: 0 })" [ngClass]="{'active-btn': activeTab === 0}">
                  Completed
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-3 leftFilters-div">
          <div class="filter-sidebar">
            <div class="filter-header">
              <span class="filter-title">Filters</span>
              <a class="clear-filter" (click)="clear()">Clear filter</a>
            </div>
            <div class="tournament-filter-skeleton" *ngFor="let item of skeletonFilters" [hidden]="!filterLoading">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <p-accordion [multiple]="true" class="filter-accordion" [activeIndex]="[0,2]" *ngIf="!filterLoading">
              <p-accordionTab header="State">
                <div class="filterBody">
                  <div class="filterHeader">
                    <div class="searchbar">
                      <input pInputText type="text" placeholder="Search for State" [(ngModel)]="searchedStateName"
                        (input)="onSearchState($event)" class="search-input" />
                      <div class="icon">
                        <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="filterMainList">
                    <div *ngFor="let state of statelist" class="filterList">
                      <p-checkbox [value]="state" [(ngModel)]="selectedState" [binary]="false"
                        (onChange)="onStateSelect($event)"></p-checkbox>
                      <label for="selectedAges">{{ state.name }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="City">
                <div class="filterBody">
                  <div class="filterHeader">
                    <div class="searchbar">
                      <input pInputText type="text" placeholder="Search for City" [(ngModel)]="searchedCityName"
                        (input)="onSearchCity($event)" class="search-input" />
                      <div class="icon">
                        <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="filterMainList">
                    <div *ngFor="let city of cityList" class="filterList">
                      <p-checkbox [value]="city" [(ngModel)]="selectedCity" [binary]="false"
                        (onChange)="onCitySelect($event)"></p-checkbox>
                      <label for="selectedAges">{{ city.name }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Category">
                <div class="filterBody pt-2">
                  <div class="filterMainList">
                    <div *ngFor="let category of categoryList" class="filterList">
                      <p-checkbox [value]="category" [(ngModel)]="selectedCategories" [binary]="false"
                        (onChange)="onCategorySelect($event)"></p-checkbox>
                      <label for="selectedAges">{{ category?.categoryName }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Academy">
                <div class="filterBody">
                  <div class="filterHeader">
                    <div class="searchbar">
                      <input pInputText type="text" placeholder="Search for Academy" [(ngModel)]="searchedAcademyName"
                        (input)="onSearchAcademy($event)" class="search-input" />
                      <div class="icon">
                        <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="filterMainList">
                    <div *ngFor="let academy of academylist" class="filterList">
                      <p-checkbox [value]="academy" [(ngModel)]="selectedAcademy" [binary]="false"
                        (onChange)="onAcademySelect($event)"></p-checkbox>
                      <label for="selectedAges">{{ academy.name }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Year">
                <div class="filterBody">
                  <div class="filterMainList">
                    <div *ngFor="let year of yearlist" class="filterList">
                      <p-checkbox [value]="year" [(ngModel)]="selectedFilterYear" [binary]="false"
                        (onChange)="onYearChange($event)"></p-checkbox>
                      <label for="selectedAges">{{ year }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
            </p-accordion>
          </div>
        </div>
        <div class="col-md-9 find-partner-page tournaments-listing-section">
          <div class="col-md-12 mobile-p-none p-0">
            <div class="right-side-section col-md-12 p-0">
              <div class="searchTournament">
                <div class="searchBar">
                  <input type="text" placeholder="Search tournaments"
                    (input)="onSearchTournament($event.target.value)" />
                  <img src="../../../assets/images/tournament/search.svg" alt="" class="icon">
                </div>
                <div class="shortBtn">
                     <button (click)="shortFilter()" class="mobileVersionShow">
                    <div class="icon">
                      <img src="../../../assets/images/tournament/sort.svg" alt="">
                    </div>
                    <div class="title">
                      Sort
                    </div>
                  </button>
                  <button (click)="shorting.toggle($event)" class="desktopVersionShow">
                    <div class="icon">
                      <img src="../../../assets/images/tournament/sort.svg" alt="">
                    </div>
                    <div class="title">
                      Sort
                    </div>
                  </button>
                  <p-overlayPanel #shorting styleClass="shortingDesktop">
                    <ng-template pTemplate="content">
                      <ul class="shortingList">
                        <li>
                          <label for="lowToHigh" class="ml-2">
                            Level: Low to High
                          </label>
                          <p-radioButton name="sortByPrice" value="ASC" inputId="lowToHigh" [(ngModel)]="sortByPriceValue" (onClick)="onClickSortButton($event)"></p-radioButton>
                        </li>
                        <li>
                          <label for="HighToLow" class="ml-2">
                            Level: High to Low
                          </label>
                          <p-radioButton name="sortByPrice" value="DESC" inputId="HighToLow" [(ngModel)]="sortByPriceValue" (onClick)="onClickSortButton($event)"></p-radioButton>
                        </li>
                      </ul>
                    </ng-template>
                  </p-overlayPanel>
                </div>
                <div class="shortBtn mobileFilters">
                  <button (click)="showMobileFilter()">
                    <div class="icon">
                      <img src="../../../assets/images/tournament/Filter.svg" alt="">
                    </div>
                    <div class="title">
                      FILTER
                    </div>
                  </button>
                </div>
              </div>
              <div class="wrapper max-w-3xl mx-auto ">
                <p-tabView class="desktop-view-tab" [(activeIndex)]="activeTab" (onChange)="onTabChange($event)">
                  <p-tabPanel header="Past Tournament">
                    <div class="slider-main">
                      <div class="tournament-card-skeleton" *ngFor="let item of skeletonCards"
                        [hidden]="!(tabLoading['past'] || (listingDeferredReady && !tabLoaded['past'])) || pastTournamentList?.length">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <div *ngFor="let tournaments  of pastTournamentList" class="listMain  ">
                        <div class="main-slider" [id]="'heading' + tournaments.id">
                          <div class="tournament-div-details">
                            <div class="tournament-header">
                              <div class="tournament-logo">
                                <img
                                  [src]="(tournaments.academyPic) ? tournaments.academyPic : '../../../../assets/images/home-page/academy_dummy.png  '"
                                  alt="" class="mainLogo">
                                <div class="sharebtn">
                                  <a href="{{tournaments?.shareurl}}" target="_blank">
                                    <button>
                                      <div class="icon">
                                        <img src="../../../assets/images/tournament/share.svg" alt="">
                                      </div>
                                      <div class="title">
                                        share
                                      </div>
                                    </button>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div class="tournamentName">
                              <h4>{{tournaments.name}}</h4>
                            </div>
                            <div class="touranmentLocation">
                              <div class="location">
                                <div class="icon">
                                  <img src="../../../assets/images/home-page/locationfilled.svg" alt="">
                                </div>
                                <div class="city">
                                  <span>{{tournaments.cityname}}</span>
                                </div>
                              </div>
                            </div>
                            <div class="tournament-table">
                              <table>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/calendar1.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Date
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table">
                                    <span>
                                      {{ tournaments?.startdate | date:'dd/MM/YY' }} - {{
                                      tournaments?.enddate | date:'dd/MM/YY' }}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/level.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Level
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table">
                                    <span class="level"
                                      *ngIf="pointsDataNameCheckFunc(tournaments) && tournaments.pointsDataName.length > 0">
                                      {{tournaments.pointsDataName}}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/category.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Categories
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table" [ngClass]="(tournaments.isViewMore) ? 'openText' : ''">
                                    <span class="CategoriesListdiv"
                                      *ngIf="matchDataNameCheckFunc(tournaments) && tournaments?.matchDataName !== null">
                                      {{(!tournaments.isViewMore) ? tournaments.matchDataName[0] :
                                      tournaments.matchDataName }}
                                    </span>
                                    <button class="viewMoreBtn"
                                      *ngIf="matchDataNameCheckFunc(tournaments) && tournaments?.matchDataName !== null && tournaments?.matchDataName.length > 1"
                                      (click)="viewMoreCategoriesToggleOption(tournaments)">
                                      {{ (!tournaments.isViewMore) ? 'VIEW MORE' : 'VIEW LESS'}}
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/draw.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Draw Type
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table">
                                    <span>
                                      {{tournaments?.drawTypeNames}}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </div>
                            <div class="tournament-fees">
                              <div class="fees"
                                *ngIf="tournaments?.minimumEntryFee !== tournaments?.maximumEntryFee; else f2">
                                ENTRY FEES: ₹{{tournaments?.minimumEntryFee}} - ₹{{tournaments?.maximumEntryFee}}
                              </div>
                              <ng-template #f2>
                                <div class="fees">
                                  ENTRY FEES: ₹{{tournaments?.maximumEntryFee}}
                                </div>
                              </ng-template>
                            </div>
                            <div class="tournament-footer">
                                <button class="fbutton" (click)="onclickTournamentdetails(tournaments.id)" style="flex-grow: 1;">
                                <span>
                                  <img src="../../../assets/images/home-page/fbutton.svg" alt="">
                                </span>
                                FACTSHEET
                              </button>
                                <button class="rbutton" (click)="onDownloadClick('bottom')"   *ngIf="tournamentIds.includes(tournaments.id)"  >
                                <span>
                                  <img src="../../../assets/images/home-page/chat.svg" alt="">
                                </span>
                                Chat
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pagination w-100 d-flex justify-content-center my-5 pagination-text">
                      <p-paginator [rows]="pageLimitFirst" #paginator [totalRecords]="pastTotalRecords" pageLinkSize="3"
                        [first]="(pageNumberFirst - 1) * pageLimitFirst" (onPageChange)="loadPastTournament($event)"
                        [rowsPerPageOptions]="pagination" [showPageLinks]="true"
                        *ngIf="pastTotalRecords > 0"></p-paginator>
                      <div *ngIf="tabLoaded['past'] && !tabLoading['past'] && pastTotalRecords == 0" class="w-100">
                        <div class="not-found-section">
                          <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                            <h4 *ngIf="tabLoaded['past'] && !tabLoading['past']">No Past Tournaments Available!</h4>
                            <p>Please check back later for updates or explore other ongoing
                              tournaments.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </p-tabPanel>
                  <p-tabPanel header="Current Tournament">
                    <div class="slider-main">
                      <div class="tournament-card-skeleton" *ngFor="let item of skeletonCards"
                        [hidden]="!(tabLoading['current'] || (listingDeferredReady && !tabLoaded['current'])) || currentTournamentList?.length">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <div *ngFor="let tournaments  of currentTournamentList" class="listMain  ">
                        <div class="main-slider" [id]="'heading' + tournaments.id">
                          <div class="tournament-div-details">
                            <div class="tournament-header">
                              <div class="tournament-logo">
                                <img
                                  [src]="(tournaments.academyPic) ? tournaments.academyPic : '../../../../assets/images/home-page/academy_dummy.png  '"
                                  alt="" class="mainLogo">
                                <div class="sharebtn">
                                  <a href="{{tournaments?.shareurl}}" target="_blank">
                                    <button>
                                      <div class="icon">
                                        <img src="../../../assets/images/tournament/share.svg" alt="">
                                      </div>
                                      <div class="title">
                                        share
                                      </div>
                                    </button>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div class="tournamentName">
                              <h4>{{tournaments.name}}</h4>
                            </div>
                            <div class="touranmentLocation">
                              <div class="location">
                                <div class="icon">
                                  <img src="../../../assets/images/home-page/locationfilled.svg" alt="">
                                </div>
                                <div class="city">
                                  <span>{{tournaments.cityname}}</span>
                                </div>
                              </div>
                            </div>
                            <div class="tournament-table">
                              <table>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/calendar1.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Date
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table">
                                    <span>
                                      {{ tournaments?.startdate | date:'dd/MM/YY' }} - {{
                                      tournaments?.enddate | date:'dd/MM/YY' }}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/level.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Level
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table">
                                    <span class="level"
                                      *ngIf="pointsDataNameCheckFunc(tournaments) && tournaments.pointsDataName.length > 0">
                                      {{tournaments.pointsDataName}}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/category.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Categories
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table" [ngClass]="(tournaments.isViewMore) ? 'openText' : ''">
                                    <span class="CategoriesListdiv"
                                      *ngIf="matchDataNameCheckFunc(tournaments) && tournaments?.matchDataName !== null">
                                      {{(!tournaments.isViewMore) ? tournaments.matchDataName[0] :
                                      tournaments.matchDataName }}
                                    </span>
                                    <button class="viewMoreBtn"
                                      *ngIf="matchDataNameCheckFunc(tournaments) && tournaments?.matchDataName !== null && tournaments?.matchDataName.length > 1"
                                      (click)="viewMoreCategoriesToggleOption(tournaments)">
                                      {{ (!tournaments.isViewMore) ? 'VIEW MORE' : 'VIEW LESS'}}
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/draw.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Draw Type
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table">
                                    <span>
                                      {{tournaments?.drawTypeNames}}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </div>
                            <div class="tournament-fees">
                              <div class="fees"
                                *ngIf="tournaments?.minimumEntryFee !== tournaments?.maximumEntryFee; else f2">
                                ENTRY FEES: ₹{{tournaments?.minimumEntryFee}} - ₹{{tournaments?.maximumEntryFee}}
                              </div>
                              <ng-template #f2>
                                <div class="fees">
                                  ENTRY FEES: ₹{{tournaments?.maximumEntryFee}}
                                </div>
                              </ng-template>
                            </div>
                            <div class="tournament-footer">
                              <button class="fbutton" (click)="onclickTournamentdetails(tournaments.id)"  style="flex-grow: 1;">
                                <span>
                                  <img src="../../../assets/images/home-page/fbutton.svg" alt="">
                                </span>
                                FACTSHEET
                              </button>
                                <button class="rbutton" (click)="onDownloadClick('bottom')"   *ngIf="tournamentIds.includes(tournaments.id)"  >
                                <span>
                                  <img src="../../../assets/images/home-page/chat.svg" alt="">
                                </span>
                                Chat
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pagination w-100 d-flex justify-content-center my-5 pagination-text">
                      <p-paginator [rows]="pageLimitFirst" #paginator [totalRecords]="currentTotalRecords"
                        pageLinkSize="3" [first]="(pageNumberFirst - 1) * pageLimitFirst"
                        (onPageChange)="loadCurrentTournament($event)" [rowsPerPageOptions]="pagination"
                        [showPageLinks]="true" *ngIf="currentTotalRecords > 0"></p-paginator>
                      <div *ngIf="tabLoaded['current'] && !tabLoading['current'] && currentTotalRecords == 0" class="w-100">
                        <div class="not-found-section">
                          <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                            <h4 *ngIf="tabLoaded['current'] && !tabLoading['current']">No Current Tournaments Available!</h4>
                            <p>Please check back later for updates or explore other ongoing
                              tournaments.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </p-tabPanel>
                  <p-tabPanel header="Upcoming Tournaments ">
                    <div class="slider-main">
                      <div class="tournament-card-skeleton" *ngFor="let item of skeletonCards"
                        [hidden]="!(tabLoading['upcoming'] || (listingDeferredReady && !tabLoaded['upcoming'])) || tournamentList?.length">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <div *ngFor="let tournaments  of tournamentList" class="listMain  ">
                        <div class="main-slider" [id]="'heading' + tournaments.id">
                          <div class="tournament-div-details">
                            <div class="tournament-header">
                              <div class="tournament-logo">
                                <img
                                  [src]="(tournaments.academyPic) ? tournaments.academyPic : '../../../../assets/images/home-page/academy_dummy.png  '"
                                  alt="" class="mainLogo">
                                <div class="sharebtn">
                                  <a href="{{tournaments?.shareurl}}" target="_blank">
                                    <button>
                                      <div class="icon">
                                        <img src="../../../assets/images/tournament/share.svg" alt="">
                                      </div>
                                      <div class="title">
                                        share
                                      </div>
                                    </button>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div class="tournamentName">
                              <h4>{{tournaments.name}}</h4>
                            </div>
                            <div class="touranmentLocation">
                              <div class="location">
                                <div class="icon">
                                  <img src="../../../assets/images/home-page/locationfilled.svg" alt="">
                                </div>
                                <div class="city">
                                  <span>{{tournaments.cityname}}</span>
                                </div>
                              </div>
                            </div>
                            <div class="tournament-table">
                              <table>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/calendar1.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Date
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table">
                                    <span>
                                      {{ tournaments?.startdate | date:'dd/MM/YY' }} - {{
                                      tournaments?.enddate | date:'dd/MM/YY' }}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/level.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Level
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table">
                                    <span class="level"
                                      *ngIf="pointsDataNameCheckFunc(tournaments) && tournaments.pointsDataName.length > 0">
                                      {{tournaments.pointsDataName}}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/category.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Categories
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table" [ngClass]="(tournaments.isViewMore) ? 'openText' : ''">
                                    <span class="CategoriesListdiv"
                                      *ngIf="matchDataNameCheckFunc(tournaments) && tournaments?.matchDataName !== null">
                                      {{(!tournaments.isViewMore) ? tournaments.matchDataName[0] :
                                      tournaments.matchDataName }}
                                    </span>
                                    <button class="viewMoreBtn"
                                      *ngIf="matchDataNameCheckFunc(tournaments) && tournaments?.matchDataName !== null && tournaments?.matchDataName.length > 1"
                                      (click)="viewMoreCategoriesToggleOption(tournaments)">
                                      {{ (!tournaments.isViewMore) ? 'VIEW MORE' : 'VIEW LESS'}}
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="left-table">
                                    <div class="lable">
                                      <div class="left-icon">
                                        <img src="../../../assets/images/home-page/draw.svg" alt="">
                                      </div>
                                      <div class="title">
                                        Draw Type
                                      </div>
                                    </div>
                                  </td>
                                  <td class="right-table">
                                    <span>
                                      {{tournaments?.drawTypeNames}}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </div>
                            <div class="tournament-fees">
                              <div class="fees"
                                *ngIf="(tournaments?.minimumEntryFee && tournaments?.maximumEntryFee) && (tournaments?.minimumEntryFee !== tournaments?.maximumEntryFee); else f2">
                                ENTRY FEES: ₹{{tournaments?.minimumEntryFee}} - ₹{{tournaments?.maximumEntryFee}}
                              </div>
                              <ng-template #f2>
                                <div class="fees" *ngIf="tournaments?.maximumEntryFee">
                                  ENTRY FEES: ₹{{tournaments?.maximumEntryFee}}
                                </div>
                              </ng-template>
                            </div>
                            <div class="tournament-footer">
                              <button class="fbutton" (click)="onclickTournamentdetails(tournaments.id)">
                                <span>
                                  <img src="../../../assets/images/home-page/fbutton.svg" alt="">
                                </span>
                                FACTSHEET
                              </button>
                              <button class="rbutton" (click)="showloginDialog(tournaments.id)"
                                [disabled]="outdate_reg_status" *ngIf="!tournamentIds.includes(tournaments.id)">
                                <span>
                                  <img src="../../../assets/images/home-page/rbutton.svg" alt="">
                                </span>
                                REGISTER
                              </button>
                              <button class="rbutton" [disabled]="true" (click)="showloginDialog(tournaments.id)"
                                *ngIf="!showRegisterButton">
                                <span>
                                  <img src="../../../assets/images/home-page/rbutton.svg" alt="">
                                </span>
                                REGISTER
                              </button>
                              <button class="rbutton"
                                (click)="withdrawtournament(tournaments.id,tournaments.lastdateofwithdraw)"
                                *ngIf="tournamentIds.includes(tournaments.id)">
                                <span>
                                  <img src="../../../assets/images/home-page/rbutton.svg" alt="">
                                </span>
                                Edit Registration
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pagination w-100 d-flex justify-content-center pagination-text">
                      <p-paginator [rows]="pageLimitFirst" #paginator [totalRecords]="totalRecords" pageLinkSize="3"
                        [first]="(pageNumberFirst - 1) * pageLimitFirst" (onPageChange)="loadTournament($event)"
                        [rowsPerPageOptions]="pagination" [showPageLinks]="true" *ngIf="totalRecords > 0"></p-paginator>
                      <div *ngIf="tabLoaded['upcoming'] && !tabLoading['upcoming'] && totalRecords == 0" class="w-100">
                        <div class="not-found-section">
                          <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                            <h4 *ngIf="tabLoaded['upcoming'] && !tabLoading['upcoming']">No Upcoming Tournaments Available!</h4>
                            <p>Please check back later for updates or explore other ongoing
                              tournaments.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </p-tabPanel>
                </p-tabView>
                <div class="mobileVersion-tab">
                  <p-tabView class="mobile-view-tab" [(activeIndex)]="activeTab" (onChange)="onTabChange($event)">
                    <p-tabPanel header="Past">
                      <div class="title-total">
                        <h4>Completed <span class="count">{{pastTotalRecords}}</span> </h4>
                      </div>
                      <div class="slider-main">
                        <div class="tournament-card-skeleton" *ngFor="let item of skeletonCards"
                          [hidden]="!(tabLoading['past'] || (listingDeferredReady && !tabLoaded['past'])) || pastTournamentList?.length">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <div *ngFor="let tournaments  of pastTournamentList" class="listMain  ">
                          <div class="main-slider" [id]="'heading' + tournaments.id">
                            <div class="tournament-div-details">
                              <div class="tournament-header">
                                <div class="tournament-logo">
                                  <div class="logoTitle">
                                    <div class="logoImg">
                                      <img
                                        [src]="(tournaments.academyPic) ? tournaments.academyPic : '../../../../assets/images/home-page/academy_dummy.png  '"
                                        alt="" class="mainLogo">
                                    </div>
                                    <div class="logoTitledetails">
                                      <div class="titleTop">
                                        <div class="date">
                                          <span>
                                            {{ tournaments?.startdate | date:'dd/MM/YY' }} - {{
                                            tournaments?.enddate | date:'dd/MM/YY' }}
                                          </span>
                                        </div>
                                        <div class="mobilesharebtn">
                                          <button>
                                            <div class="icon">
                                              <img src="../../../assets/images/tournament/share.svg" alt="">
                                            </div>
                                            <div class="title">
                                              share
                                            </div>
                                          </button>
                                        </div>
                                      </div>
                                      <div class="tournamentName">
                                        <h5>{{tournaments.name}}</h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="tournament-table">
                                <table>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/tournament/level.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Level
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table">
                                      <span class="level">
                                        {{tournaments.pointsDataName}}
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/tournament/tlocation.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Location
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table">
                                      {{tournaments.cityname}}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/home-page/category.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Categories
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table" [ngClass]="(tournaments.isViewMore) ? 'openText' : ''">
                                      <span class="CategoriesListdiv">

                                        {{(!tournaments.isViewMore) ? tournaments.matchDataName[0] :
                                        tournaments.matchDataName }}
                                      </span>
                                      <button class="viewMoreBtn"
                                        (click)="viewMoreCategoriesToggleOption(tournaments)">{{
                                        (!tournaments.isViewMore) ? 'VIEW MORE' : 'VIEW LESS'}}</button>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/home-page/draw.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Draw Type
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table">
                                      <span>
                                        {{tournaments?.drawTypeNames}}
                                      </span>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                              <div class="tournament-fees">
                                <div class="fees"
                                  *ngIf="tournaments?.minimumEntryFee !== tournaments?.maximumEntryFee; else f2">
                                  ENTRY FEES: ₹{{tournaments?.minimumEntryFee}} - ₹{{tournaments?.maximumEntryFee}}
                                </div>
                                <ng-template #f2>
                                  <div class="fees">
                                    ENTRY FEES: ₹{{tournaments?.maximumEntryFee}}
                                  </div>
                                </ng-template>
                              </div>
                              <div class="tournament-footer">
                                <button class="fbutton" (click)="onclickTournamentdetails(tournaments.id)" style="flex-grow: 1;">
                                <span>
                                  <img src="../../../assets/images/home-page/fbutton.svg" alt="">
                                </span>
                                FACTSHEET
                              </button>
                                <button class="rbutton" (click)="onDownloadClick('bottom')"   *ngIf="tournamentIds.includes(tournaments.id)"  >
                                <span>
                                  <img src="../../../assets/images/home-page/chat.svg" alt="">
                                </span>
                                Chat
                              </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="pagination w-100 d-flex justify-content-center my-5 pagination-text">
                        <p-paginator [rows]="pageLimitFirst" #paginator [totalRecords]="pastTotalRecords"
                          pageLinkSize="3" [first]="(pageNumberFirst - 1) * pageLimitFirst"
                          (onPageChange)="loadPastTournament($event)" [rowsPerPageOptions]="pagination"
                          [showPageLinks]="true" *ngIf="pastTotalRecords > 0"></p-paginator>
                        <div *ngIf="tabLoaded['past'] && !tabLoading['past'] && pastTotalRecords == 0" class="w-100">
                          <div class="not-found-section">
                            <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                              <h4>No Past Tournaments Available!</h4>
                              <p>Please check back later for updates or explore other ongoing
                                tournaments.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </p-tabPanel>
                    <p-tabPanel header="Current">
                      <div class="title-total">
                        <h4>Live <span class="count">{{currentTotalRecords}}</span> </h4>
                      </div>
                      <div class="slider-main">
                        <div class="tournament-card-skeleton" *ngFor="let item of skeletonCards"
                          [hidden]="!(tabLoading['current'] || (listingDeferredReady && !tabLoaded['current'])) || currentTournamentList?.length">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <div *ngFor="let tournaments  of currentTournamentList" class="listMain  ">
                          <div class="main-slider" [id]="'heading' + tournaments.id">
                            <div class="tournament-div-details">
                              <div class="tournament-header">
                                <div class="tournament-logo">
                                  <div class="logoTitle">
                                    <div class="logoImg">
                                      <img
                                        [src]="(tournaments.academyPic) ? tournaments.academyPic : '../../../../assets/images/home-page/academy_dummy.png  '"
                                        alt="" class="mainLogo">
                                    </div>
                                    <div class="logoTitledetails">
                                      <div class="titleTop">
                                        <div class="date">
                                          <span>
                                            {{ tournaments?.startdate | date:'dd/MM/YY' }} - {{
                                            tournaments?.enddate | date:'dd/MM/YY' }}
                                          </span>
                                        </div>
                                        <div class="mobilesharebtn">
                                          <button>
                                            <div class="icon">
                                              <img src="../../../assets/images/tournament/share.svg" alt="">
                                            </div>
                                            <div class="title">
                                              share
                                            </div>
                                          </button>
                                        </div>
                                      </div>
                                      <div class="tournamentName">
                                        <h5>{{tournaments.name}}</h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="tournament-table">
                                <table>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/tournament/level.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Level
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table">
                                      <span class="level">
                                        {{tournaments.pointsDataName}}
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/tournament/tlocation.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Location
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table">
                                      {{tournaments.cityname}}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/home-page/category.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Categories
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table" [ngClass]="(tournaments.isViewMore) ? 'openText' : ''">
                                      <span class="CategoriesListdiv" *ngIf="tournaments.matchDataName">

                                        {{(!tournaments.isViewMore) ? tournaments.matchDataName[0] :
                                        tournaments.matchDataName }}
                                      </span>
                                      <button class="viewMoreBtn"
                                        (click)="viewMoreCategoriesToggleOption(tournaments)">{{
                                        (!tournaments.isViewMore) ? 'VIEW MORE' : 'VIEW LESS'}}</button>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/home-page/draw.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Draw Type
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table">
                                      <span>
                                        {{tournaments?.drawTypeNames}}
                                      </span>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                              <div class="tournament-fees">
                                <div class="fees"
                                  *ngIf="tournaments?.minimumEntryFee !== tournaments?.maximumEntryFee; else f2">
                                  ENTRY FEES: ₹{{tournaments?.minimumEntryFee}} - ₹{{tournaments?.maximumEntryFee}}
                                </div>
                                <ng-template #f2>
                                  <div class="fees">
                                    ENTRY FEES: ₹{{tournaments?.maximumEntryFee}}
                                  </div>
                                </ng-template>
                              </div>
                              <div class="tournament-footer">
                                  <button class="fbutton" (click)="onclickTournamentdetails(tournaments.id)"  style="flex-grow: 1;">
                                <span>
                                  <img src="../../../assets/images/home-page/fbutton.svg" alt="">
                                </span>
                                FACTSHEET
                              </button>
                                <button class="rbutton" (click)="onDownloadClick('bottom')"   *ngIf="tournamentIds.includes(tournaments.id)"  >
                                <span>
                                  <img src="../../../assets/images/home-page/chat.svg" alt="">
                                </span>
                                Chat
                              </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="pagination w-100 d-flex justify-content-center my-5 pagination-text">
                        <p-paginator [rows]="pageLimitFirst" #paginator [totalRecords]="currentTotalRecords"
                          pageLinkSize="3" [first]="(pageNumberFirst - 1) * pageLimitFirst"
                          (onPageChange)="loadCurrentTournament($event)" [rowsPerPageOptions]="pagination"
                          [showPageLinks]="true" *ngIf="currentTotalRecords > 0"></p-paginator>
                        <div *ngIf="tabLoaded['current'] && !tabLoading['current'] && currentTotalRecords == 0" class="w-100">
                          <div class="not-found-section">
                            <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                              <h4>No Current Tournaments Available!</h4>
                              <p>Please check back later for updates or explore other ongoing
                                tournaments.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </p-tabPanel>
                    <p-tabPanel header="Upcoming">
                      <div class="title-total">
                        <h4>UPCOMING <span class="count">{{totalRecords}}</span> </h4>
                      </div>
                      <div class="slider-main">
                        <div class="tournament-card-skeleton" *ngFor="let item of skeletonCards"
                          [hidden]="!(tabLoading['upcoming'] || (listingDeferredReady && !tabLoaded['upcoming'])) || tournamentList?.length">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <div *ngFor="let tournaments  of tournamentList" class="listMain  ">
                          <div class="main-slider" [id]="'heading' + tournaments.id">
                            <div class="tournament-div-details">
                              <div class="tournament-header">
                                <div class="tournament-logo">
                                  <div class="logoTitle">
                                    <div class="logoImg">
                                      <img
                                        [src]="(tournaments.academyPic) ? tournaments.academyPic : '../../../../assets/images/home-page/academy_dummy.png  '"
                                        alt="" class="mainLogo">
                                    </div>
                                    <div class="logoTitledetails">
                                      <div class="titleTop">
                                        <div class="date">
                                          <span>
                                            {{ tournaments?.startdate | date:'dd/MM/YY' }} - {{
                                            tournaments?.enddate | date:'dd/MM/YY' }}
                                          </span>
                                        </div>
                                        <div class="mobilesharebtn">
                                          <button>
                                            <div class="icon">
                                              <img src="../../../assets/images/tournament/share.svg" alt="">
                                            </div>
                                            <div class="title">
                                              share
                                            </div>
                                          </button>
                                        </div>
                                      </div>
                                      <div class="tournamentName">
                                        <h5>{{tournaments.name}}</h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="tournament-table">
                                <table>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/tournament/level.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Level
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table">
                                      <span class="level">
                                        {{tournaments.pointsDataName}}
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/tournament/tlocation.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Location
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table">
                                      {{tournaments.cityname}}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/home-page/category.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Categories
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table" [ngClass]="(tournaments.isViewMore) ? 'openText' : ''">
                                      <span class="CategoriesListdiv"
                                        *ngIf="matchDataNameCheckFunc(tournaments) && tournaments?.matchDataName !== null">
                                        {{(!tournaments.isViewMore) ? tournaments.matchDataName[0] :
                                        tournaments.matchDataName }}
                                      </span>
                                      <button class="viewMoreBtn"
                                        *ngIf="matchDataNameCheckFunc(tournaments) && tournaments?.matchDataName !== null && tournaments?.matchDataName.length > 1"
                                        (click)="viewMoreCategoriesToggleOption(tournaments)">
                                        {{ (!tournaments.isViewMore) ? 'VIEW MORE' : 'VIEW LESS'}}
                                      </button>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="left-table">
                                      <div class="lable">
                                        <div class="left-icon">
                                          <img src="../../../assets/images/home-page/draw.svg" alt="">
                                        </div>
                                        <div class="title">
                                          Draw Type
                                        </div>
                                      </div>
                                    </td>
                                    <td class="right-table">
                                      <span>
                                        {{tournaments?.drawTypeNames}}
                                      </span>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                              <div class="tournament-fees">
                                <div class="fees"
                                  *ngIf="tournaments?.minimumEntryFee !== tournaments?.maximumEntryFee; else f2">
                                  ENTRY FEES: ₹{{tournaments?.minimumEntryFee}} - ₹{{tournaments?.maximumEntryFee}}
                                </div>
                                <ng-template #f2>
                                  <div class="fees">
                                    ENTRY FEES: ₹{{tournaments?.maximumEntryFee}}
                                  </div>
                                </ng-template>
                              </div>
                              <div class="tournament-footer">
                                <button class="fbutton" (click)="onclickTournamentdetails(tournaments.id)">
                                  <span>
                                    <img src="../../../assets/images/home-page/fbutton.svg" alt="">
                                  </span>
                                  FACTSHEET
                                </button>
                                <button class="rbutton" (click)="showloginDialog(tournaments.id)"
                                  [disabled]="outdate_reg_status" *ngIf="!tournamentIds.includes(tournaments.id)">
                                  <span>
                                    <img src="../../../assets/images/home-page/rbutton.svg" alt="">
                                  </span>
                                  REGISTER
                                </button>
                                <button class="rbutton" [disabled]="true" (click)="showloginDialog(tournaments.id)"
                                  *ngIf="!showRegisterButton">
                                  <span>
                                    <img src="../../../assets/images/home-page/rbutton.svg" alt="">
                                  </span>
                                  REGISTER
                                </button>
                                <button class="rbutton"
                                  (click)="withdrawtournament(tournaments.id,tournaments.lastdateofwithdraw)"
                                  *ngIf="tournamentIds.includes(tournaments.id)">
                                  <span>
                                    <img src="../../../assets/images/home-page/rbutton.svg" alt="">
                                  </span>
                                  Edit Registration
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="pagination w-100 d-flex justify-content-center my-5 pagination-text">
                        <p-paginator [rows]="pageLimitFirst" #paginator [totalRecords]="totalRecords" pageLinkSize="3"
                          [first]="(pageNumberFirst - 1) * pageLimitFirst" (onPageChange)="loadTournament($event)"
                          [rowsPerPageOptions]="pagination" [showPageLinks]="true"
                          *ngIf="totalRecords > 0"></p-paginator>
                        <div *ngIf="tabLoaded['upcoming'] && !tabLoading['upcoming'] && totalRecords == 0" class="w-100">
                          <div class="not-found-section">
                            <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                              <h4>No Upcoming Tournaments Available!</h4>
                              <p>Please check back later for updates or explore other ongoing
                                tournaments.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </p-tabPanel>
                  </p-tabView>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End Product -->
</main>
<!-- End #main -->
<p-dialog id="completeProfile" [(visible)]="welcomeLogin"
  [breakpoints]="{ '960px': '500px', '768px': 'calc(100% - 60px)', '389px': 'calc(100% - 30px)' }"
  [style]="{ width: '500px' }" [modal]="true" [draggable]="false" [resizable]="false"
  (onHide)="hideWelcomeLoginDialog()">
  <div class="Welcome-popup">
    <h4>
      Complete Your Profile!
    </h4>
    <p>You are required to complete your profile to proceed further</p>
    <hr class="line-div">
    <div class="actionButton">
      <div class="completeProfile_Button">
        <button type="button" [routerLink]="(!isContestVerified) ? '/profile-edit2' : '/dob-verification'"
          [queryParams]="(!isContestVerified) ? { page : 'tournaments'} : { isAbout18: isAbove18Check, page : 'tournaments'}">Complete
          Profile</button>
      </div>
      <div class="skip_Button">
        <button (click)="hideWelcomeLoginDialog()">Cancel</button>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog id="Entertournament" [(visible)]="TournamentEntry"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }"
  [modal]="TournamentEntry" [draggable]="false" [resizable]="false" (onHide)="catageclose()">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">TOURNAMENT REGISTRATION</h5>
  </ng-template>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
        max-width: 100%;">
    <div class="modal-content">
      <div class="modal-body">
        <div class="add-even col-md-12">
          <div class="list-tournamnet-add">
            <form [formGroup]="myForm">
              <div formArrayName="fields" class="w-100 add-categorey-section">
                <div class=" selectcategory-div" *ngFor="let fieldGroup of fieldsFormArray.controls; let i = index"
                  [formGroupName]="i">
                  <!-- <div class="col-md-12 list">
                    <label for="categories">Categories</label>
                    <p-dropdown inputId="categories{{i}}" [options]="categoryAndAgeGroupList"
                      formControlName="categories" [disabled]="disableCategories[i]"
                      emptyFilterMessage="No eligible tournament category and age group or entries might be full"
                      appendTo="body" optionLabel="categoryName"
                      (onChange)="onTournamentCategorySelect($event, i)"></p-dropdown>
                  </div> -->
                  <ng-container *ngIf="hasAnyTournamentCategory; else noCategories">
                  
                    <p-dropdown inputId="categories{{i}}" [options]="getSelectableCategoriesForField(i)" formControlName="categories"
                      [disabled]="disableCategories[i]"
                      emptyFilterMessage="No eligible tournament category and age group or entries might be full" appendTo="body"
                      optionLabel="categoryName" (onChange)="onTournamentCategorySelect($event, i)">
                    </p-dropdown>
                  </ng-container>
                  <ng-template #noCategories>
                    <div class="no-category-message">
                      <span>ⓘ</span>
                      <span>No categories available for your age group</span>
                    </div>
                  </ng-template>
                  <div class="category-full-message" *ngIf="getFullCategoryNamesForField(i)">
                    {{ getFullCategoryNamesForField(i) }} - Category is Full
                  </div>
                  <div class="addPartner" id="add_double_partner_{{i}}" style="display: none;">
                    <button class="add-partner" (click)="showaddPartnerDialog(i)">ADD PARTNER</button>
                  </div>
                  <div id="double_partner_{{i}}" style="display: none;">
                    <h6 style="margin-top: 10px;" class="title-lable">Doubles Partner</h6>
                    <div class="form">
                      <div class="input-group mb-3">
                        <input type="hidden" formControlName="doublePlayerId" inputId="doublePlayerId{{i}}"
                          name="searchemailuserid" class="form-control" id="exampleFormControlInput1">
                        <input type="text" formControlName="doubleUserEmail" class="form-control doubleInputForm"
                          placeholder="-" aria-label="Recipient's username" aria-describedby="changePlayer" disabled>
                        <span class="input-group-text" (click)="showaddPartnerDialog(i)" id="changePlayer">
                          CHANGE PARTNER
                        </span>
                      </div>
                    </div>
                    <div class="notes">
                      <div class="icon">
                        <img src="../../../assets/images/tournament/information-circle.svg" alt="">
                      </div>
                      <p>Ensure the partner is registered on the app at least 30 minutes before the tournament starts.
                      </p>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <!-- Display the price for each selected age group -->
                    <input type="hidden" [formControlName]="getPriceFormControlName(i)" [value]="selectedEntryFees[i]">
                  </div>
                  <div class="col-md-12 remove-category" *ngIf="i>0">
                    <button *ngIf="i>0" type="button" (click)="removeField(i)">Remove
                      Category</button>
                  </div>
                </div>
              </div>
              <div class="category-full-message" *ngIf="registrationCategoryErrorMessage">
                {{ registrationCategoryErrorMessage }}
              </div>
              <div class="add-more-btn">
                <button type="button" (click)="addField()" [disabled]="!isTournamentCatgeorySelected || !hasAddableCategories">
                  <i class="bx bx-plus" style="color: #000;"></i>Add Another Event</button>
              </div>
              <div class="col-md-12 d-none" *ngIf="totalEntryFee() !== 0">
                <h6 class="JuniorBoysSingles">Enter Fees : {{ totalEntryFee() }} TPL Cash</h6>
              </div>
            </form>
            <div class="form-check p-0 d-flex align-items-center mb-2 mt-2"
              [ngClass]="showTermsAndConditionError ? 'Error-div' : ''">
              <p-checkbox binary="true" [value]="termsAndConditions" (onChange)="onTermsAndConditionsSelect($event)"
                [(ngModel)]="termsAndConditions" inputId="termsAndConditions"></p-checkbox>
              <label class="form-check-label termsandconditiontext" for="defaultCheck1">
                I accept the <a class="termsConditionText" href="/termsandcondition#TPLtournament">terms and
                  conditions</a>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button [ngClass]="termsAndConditions && myForm.valid && !hasFullSelectedCategory ? 'enable-btn' : 'disable-btn'" type="button"
        class="btn btn-primary mx-auto" (click)="walletPay()" [disabled]="!termsAndConditions || !myForm.valid || hasFullSelectedCategory">CONFIRM
        REGISTRATION</button>
    </div>
    <div class="footerApp">
      <div class="footerhead">
        <div class="logo">
          <img src="../../../assets/images/tournament/logo.png" alt="">
        </div>
        <div class="desciption">
          <h4>TPL App</h4>
          <p>Other account tournament registration only on app</p>
        </div>
      </div>
      <div class="footerDivider">
        <img src="../../../assets/images/tournament/hr.png" alt="">
      </div>
      <div class="footerfoot">
        <h6>DOWNLOAD NOW</h6>
        <ul>
          <li>
            <button>
              <img src="../../../assets/images/tournament/playstore.png" alt="">
            </button>
          </li>
          <li>
            <button>
              <img src="../../../assets/images/tournament/appsotre.png" alt="">
            </button>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</p-dialog>
<p-dialog id="Entertournamentpartner" [(visible)]="addPartner"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="addPartner"
  [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">TOURNAMENT REGISTRATION</h5>
  </ng-template>
  <form [formGroup]="emailForm" class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    style="margin: 0px!important;    width: 100%;  max-width: 100%;">
    <div class="modal-content">
      <div class="modal-body">
        <div class="add-even col-md-12">
          <div class="col-md-12 list">
            <h6>PARTNER’S MOBILE NUMBER</h6>
            <div class="mobile0numberField">
              <div class="countryCode">
                <p-dropdown inputId="phoneCode" formControlName="phoneCode" appendTo="body" [options]="countryCodeList"
                  optionLabel="phone_code" (onChange)="setCountryCode($event)" [filter]="true"
                  [ngClass]="{ 'ng-dirty ng-invalid': submitted && this.emailForm.get('phoneCode').errors }">
                  <ng-template pTemplate="selectedItem" let-selectedOption>
                    <div class="flex justify-content-center align-items-center gap-2">
                      <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                        [class]="'flag flag-' + selectedOption.code.toLowerCase()" style="width: 18px" />
                      <div>{{ selectedOption.phone_code }}</div>
                    </div>
                  </ng-template>
                  <ng-template let-country pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                        [class]="'flag flag-' + country.code.toLowerCase()" style="width: 18px" />&nbsp;&nbsp;
                      <span>{{ country?.phone_code }}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
              <p-inputNumber [useGrouping]="false" id="inputtext-left" formControlName="mobileNumber" [maxlength]="10"
                type="number" maxlength="10" class="form-control" id="exampleFormControlInput1"
                placeholder="Mobile Number" mode="decimal" (change)="clearEmailErrors()" required>
              </p-inputNumber>
            </div>
            <div class="notes">
              <div class="icon">
                <img src="../../../assets/images/tournament/information-circle.svg" alt="">
              </div>
              <p>Enter mobile no. of a player that is registered to TPL.</p>
            </div>
            <div *ngIf="emailForm.get('mobileNumber').hasError('required') && emailForm.get('mobileNumber').touched"
              class="text-danger">Mobile Number required</div>
            <div
              *ngIf="emailForm.get('mobileNumber').hasError('maxlength') && !emailForm.get('mobileNumber').hasError('required') && emailForm.get('mobileNumber').touched"
              class="text-danger">Enter a valid Mobile Number</div>
            <div
              *ngIf="!emailForm.get('mobileNumber').hasError('maxlength') && !emailForm.get('mobileNumber').hasError('required')  && !duplicateEmailError && emailerrormsg"
              class="text-danger">Mobile Number not Found</div>
            <div *ngIf="duplicateEmailError && !emailerrormsg" class="text-danger">You can't use your own register
              Mobile Number</div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="form-check p-0 d-flex align-items-center mb-2 mt-2"
          [ngClass]="showTermsAndConditionError ? 'Error-div' : ''">
          <p-checkbox binary="true" [value]="addPartnerTermsAndConditions"
            (onChange)="onAddPartnerTermsAndConditionsSelect($event)" [(ngModel)]="addPartnerTermsAndConditions"
            [ngModelOptions]="{standalone: true}" inputId="termsAndConditions"></p-checkbox>
          <label class="form-check-label termsandconditiontext" for="defaultCheck1">
            I accept the <a class="termsConditionText" href="/termsandcondition#TPLtournament">terms and
              conditions</a>
          </label>
        </div>
        <button [ngClass]="addPartnerTermsAndConditions && emailForm.valid ? 'enable-btn' : 'disable-btn'" type="button"
          class="btn btn-primary mx-auto" (click)="addedPartner()"
          [disabled]="!addPartnerTermsAndConditions || !emailForm.valid">Add Partner</button>
      </div>
    </div>
  </form>
</p-dialog>
<p-dialog id="Pay" [(visible)]="Walletdialog" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }"
  [style]="{ width: '400px' }" [modal]="Walletdialog" [draggable]="false" [resizable]="false" (onHide)="onHideWalletDialog()">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">TOURNAMENT REGISTRATION</h5>
  </ng-template>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
        max-width: 100%;">
    <div class="modal-content">
      <div class="paymentPayBody">
        <div class="summery" *ngIf="Walletdialog">
          <h6>SUMMARY</h6>
          <div *ngIf="selectedTournamentCategory && selectedAgeGroup && selectedEntryFees"
            class="table-selectform w-100">
            <table class="table  ">
              <tbody>
                <!-- Loop through selected tournament categories and age groups -->
                <tr *ngFor="let category of selectedTournamentCategory; index as i;">
                  <td>{{ category.matchname }} - {{ category.agegroupname }}</td>
                  <td class="rightTd">₹{{ selectedEntryFees[i] }}</td>
                </tr>
                <!-- <tr *ngIf="fees?.platformFeeStatus">
                  <td>Platform Fee</td>
                  <td class="rightTd">{{ (fees?.platformFeeType === 'flat') ? '₹' : ''}} {{ fees?.platformFee }} {{ (fees?.platformFeeType === 'percentage') ? '%' : ''}}</td>
                </tr> -->
                 <tr *ngIf="fees?.platformFeeStatus">
                  <td>
                    Platform Fee
                      <span *ngIf="fees?.platformFeeType === 'percentage'">
                        ({{ fees?.platformFee }}%)
                       </span>
                      </td>
                       <td class="rightTd">  ₹{{ getPlatformFeeAmount() | number:'1.2-2' }}
                         </td>
                         </tr>
                <!-- <tr *ngIf="fees?.convenienceFeeStatus">
                  <td>Convenience Fee</td>
                  <td class="rightTd">{{ (fees?.convenienceFeeType === 'flat') ? '₹' : ''}} {{ fees?.convenienceFee }} {{ (fees?.convenienceFeeType === 'percentage') ? '%' : ''}}</td>
                </tr> -->
                <tr *ngIf="fees?.convenienceFeeStatus">
                        <td>
                            Convenience Fee
                             <span *ngIf="fees?.convenienceFeeType === 'percentage'">
                               ({{ fees?.convenienceFee }}%)
                              </span>
                              </td>
                               <td class="rightTd">
                      ₹{{ getConvenienceFeeAmount() | number:'1.2-2' }}
                       </td>
                      </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    <strong>TOTAL AMOUNT</strong>
                  </td>
                  <td class="rightTd">
                    <strong>₹{{ totalEntryFee() }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div class="paymentFoot">
        <form action="#">
          <div class="col-md-12 add-buttons">
            <ul>
              <li class="tpl-cash d-flex">
                <label class="form-check-label" for="flexRadioDefault1">
                  <input class="form-check-input" type="checkbox" name="flexRadioDefault" id="flexRadioDefault1" [(ngModel)]="isRadioButtonClicked"
                    (click)="onRadioClick()" checked>
                  <span class="icon"> <img src="../../../assets/images/tournament/wallet.svg" alt=""> </span> TPL Wallet
                  Balance
                </label>
                <div class="buttons d-flex ">
                  <span class="Balance mr-2"> ₹{{walletBalance | number:'1.2-2'}}</span>
                </div>
              </li>
            </ul>
            <div class="thamkyou-notes" *ngIf="thankYouMsg">
              <p-messages severity="success">
                <ng-template pTemplate>
                  <img src="../../../assets/img/Tournament/checked.png" width="32" />
                  <div class="note-div-section w-100 ml-2">
                    <div class="ml-1 w-100">Thank You!</div>
                    <div class="note">
                      Your wallet has been successfully credited with the amount.
                    </div>
                  </div>
                </ng-template>
              </p-messages>
            </div>
            <p class="cash-ms" [ngClass]="{ 'disabled-message': !isRegisterButtonEnabled()}">
              <span *ngIf="displayCashMs">After Transaction Your Balance Will Be ₹{{
                totalleftCash}}</span>
            </p>
            <p class="add-money-message" *ngIf="showAddMoneyMessage">Please add money to your wallet</p>
          </div>
           <div class="registration-expired-message" *ngIf="isRegistrationExpired">
            <div class="expired-icon">
              <i class="pi pi-exclamation-circle"></i>
            </div>
          
            <div class="expired-content">
              <strong>Registration deadline is over</strong>
            </div>
          </div>
          <div class="totalPaybal">
            <div class="title">
              TOTAL AMOUNT PAYABLE
            </div>
            <div class="amount">₹{{ totalEntryFee() }}</div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="form-check p-0 d-flex align-items-center mb-2 mt-2"
      [ngClass]="showTermsAndConditionError ? 'Error-div' : ''">
      <p-checkbox binary="true" [value]="walletDialogTermsAndConditions"
        (onChange)="onWalletDialogTermsAndConditionsSelect($event)" [(ngModel)]="walletDialogTermsAndConditions"
        [ngModelOptions]="{standalone: true}" inputId="termsAndConditions"></p-checkbox>
      <label class="form-check-label termsandconditiontext" for="defaultCheck1">
        I accept the <a class="termsConditionText" href="/termsandcondition#TPLtournament">terms and
          conditions</a>
      </label>
    </div>
    <button [ngClass]="walletDialogTermsAndConditions && !isRegistrationExpired ? 'enable-btn': 'disable-btn'" type="button"
      class="btn btn-primary mx-auto" (click)="thankyouModal()" [disabled]="!walletDialogTermsAndConditions">Pay ₹{{
      totalEntryFee() }}</button>
  </div>
</p-dialog>
<p-dialog id="add-cash" [(visible)]="Addcashmodal" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }"
  [style]="{ width: '500px' }" [modal]="true" [draggable]="false" [resizable]="false" (onHide)="cashclose()">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
    <div class="modal-content">
      <div class="modal-header card-title">
        <h1 class="modal-title fs-5" id="add-cashLabel">Add Cash</h1>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body add-cash pay">
        <div class="card-body">
          <div class="payment-info flex justify-space-between">
            <div class="column shipping w-100">
              <form [formGroup]="addCashForm" *ngIf="this.addCashForm">
                <div class="container-fluid grid">
                  <div class="row pull-center">
                    <div class="col-md-12 mobile-p-none ">
                      <div class="wallet-screen" style="display: block;">
                        <div class="total-amount">
                          <div class="wallet-icons">
                            <div class="icon">
                              <i class='bx bx-wallet-alt'></i>
                            </div>
                            <h1>Enter Amount</h1>
                          </div>
                          <div class="col-md-12 add-buttons">
                            <div class="add-money-form col-md-12">
                              <input type="number" id="myInput2" placeholder="₹ 0" formControlName="amount" readonly
                                [(ngModel)]="addedAmount" [ngClass]="{ 'is-invalid': submitted && a.amount.errors }">
                              <div *ngIf="submitted && a.amount.errors" class="invalid-feedback">
                                <div *ngIf="a.amount.errors.required">Amount is required</div>
                                <div *ngIf="a.amount.errors">Only Numbers allowed</div>
                              </div>
                              <div class="p-field p-col-12 msg-div">
                                <p-messages severity="info">
                                  <ng-template pTemplate>
                                    <i class="pi pi-info-circle"></i>
                                    <div class="ml-2">Please Note: For iPhone users - To make a payment using Gpay,
                                      select "Others" option in the UPI menu and manually enter your UPI ID.</div>
                                  </ng-template>
                                </p-messages>
                              </div>
                            </div>
                            <div id="text-out">{{outputText}}</div>
                            <div class="col-md-12 text-center">
                              <a href="#" (click)="onCashSubmit($event)" class="button button-primary"> Add to Wallet
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog id="Entertournamentthank" [(visible)]="thanYoumodal"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="true"
  [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry </h5>
  </ng-template>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
    <div class="modal-content">
      <div class="modal-header">
        <div class="headings col-md-12">
          <h6>{{tournamentname}}</h6>
          <p class="note" *ngIf="!(this.walletdata?.tournamentPlayerCategoryArr.length === this.walletdata?.refundedCategories.length)">You have successfully registered</p>
          <p class="text-danger" *ngIf="refundTournamentCategoriesMessage">Note: {{ refundTournamentCategoriesMessage }}</p>
        </div>
        <div class="countdown-container">
          <div class="countdown-circle" [style.animation-duration.seconds]="10"></div>
          <div class="countdown-text">{{ countdown }}</div>
          <br>
        </div>
        <div class="timer-alert">
          Please wait 10 seconds.
        </div>
        <p class="note text-left mainNotes">
          <span> <img src="../../../assets/images/tournament/information-orange.svg" alt=""> </span>
          <span>Your payment will be automatically debited from Wallet.</span>
        </p>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog id="Entertournamentview" [(visible)]="WithdrawModal"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="true"
  [draggable]="false" [resizable]="false" (onHide)="Withdrawclose()">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry </h5>
  </ng-template>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
    <div class="modal-content">
      <div class="modal-header">
        <div class="headings col-md-12">
          <h6>{{tournamentname}}</h6>
          <p class="note">
            Please select a category from the below list to withdraw.
          </p>
        </div>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="add-even col-md-12">
          <div class="event-details-list" *ngFor="let registeredtournamentdatalist of registeredtournamentdata">
            <div class="list-div-selection" [ngClass]="{'selected': wid === registeredtournamentdatalist.id}">
              <div class="event-details">
                <div class="Event-cate">
                  <ul>
                    <li>
                      <span class="small-heading">{{registeredtournamentdatalist.matchTypeName}}</span>
                      <p>{{registeredtournamentdatalist.ageGroupName}}</p>
                    </li>
                  </ul>
                </div>
                <div class="checkbox-icon">
                  <label for="{{registeredtournamentdatalist.id}}">
                    <input type="radio" id="{{registeredtournamentdatalist.id}}" name="fav_language"
                      (click)="withdraw_select(registeredtournamentdatalist.id,registeredtournamentdatalist.tournamentName,registeredtournamentdatalist.matchTypeName,registeredtournamentdatalist.ageGroupName)">
                    <span>Withdraw</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="add-more-btn col-md-12"><button type="button" (click)="registeredAddField();"> Add Another Event
              <i class="bx bx-plus" style="color: #fff;"></i></button></div>
        </div>
      </div>
      <div *ngIf="withdraw_confirm_status==true" style="text-align: center;">
        <b style="color: red;">Withdraw date over</b>
      </div>
      <div class="modal-footer">
        <button type="button" [disabled]="withdrawButtonClicked || withdraw_confirm_status"
          class="btn btn-primary mx-auto" (click)="Withdrawconfirmmodal()">Confirm</button>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog id="widthdraw-confitmation" [(visible)]="WithdrawcnfModal"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="true"
  [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">Withdraw Confirmation </h5>
  </ng-template>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
    <div class="modal-content">
      <div class="modal-body">
        <p>Are you sure you want to withdraw from the tournament category? Please note that this action can not be
          undone, and
          your participation in the tournament will be cancelled. </p>
        <div class="add-even col-md-12">
          <div class="event-details-list">
            <div class="list-div-selection">
              <div class="event-details">
                <div class="title">{{tname}}</div>
                <div class="Event-cate">
                  <ul>
                    <li>
                      <span class="small-heading">{{mtn}}</span>
                      <p>{{agn}}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <p>After the withdrawal, the entry fee amount will be credited back to your TPL wallet.
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary mx-auto " (click)="thankyouwithdraw()">Proceed with the
          withdrawal</button>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog id="Entertournamentthank" [(visible)]="thankwithdraw"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="true"
  [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">Tournament Entry </h5>
  </ng-template>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
    <div class="modal-content">
      <div class="modal-header">
        <div class="headings col-md-12">
          <h6>{{tournamentname}}</h6>
          <div class="countdown-container">
            <div class="countdown-circle" [style.animation-duration.seconds]="10"></div>
            <div class="countdown-text">{{ countdown }}</div>
            <br>
          </div>
          <div class="timer-alert">
            Please wait
          </div>
          <p class="note">We are processing your refund request in the tournament category. Once the refund is processed
            successfully, please check Wallet Balance.</p>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog [closable]="true" [(visible)]="showForgotPasswordForm" [modal]="true" [style]="{width: '500px'}"
  id="forgot-password" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false">
  <section *ngIf="showForgotPasswordForm" class="login-page-section">
    <div class="section-title text-center">
      <p> Forgot Password
      </p>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 ">
          <div class="col-md-12 login-page">
            <form [formGroup]="forgotPassForm">
              <div class="row">
                <div class="col-lg-12">
                  <div class="style-form-group">
                    <input type="email" formControlName="email" class="form-control form-input"
                      placeholder="Your Email *"
                      [ngClass]="{ 'is-invalid': submitted && forgotPassValidation.email.errors }">
                    <div *ngIf="submitted && forgotPassValidation.email.errors" class="invalid-feedback">
                      <div *ngIf="forgotPassValidation.email.errors.required">Email is
                        required</div>
                      <div *ngIf="forgotPassValidation.email.errors.pattern">Email must be a
                        valid
                        email address</div>
                    </div>
                    <div *ngIf="successMessage" style="color:green;">{{successMessage.message}}
                    </div>
                    <div *ngIf="errorMessage" style="color:red;">{{errorMessage}}</div>
                  </div>
                </div>
              </div>
              <div class="button pt-2 pt-lg-3">
                <button class="forgot-pass-submit" (click)="onForgotPassSubmit()">Submit</button>&nbsp;&nbsp;
                <button class="forgot-pass-back" (click)="onForgotPassBack()">Back</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</p-dialog>
<p-dialog id="mobileFilter" [(visible)]="mobilFilter" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }"
  [style]="{ width: '400px' }" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false">
  <ng-template pTemplate="header">
    <div class="filterHeader">
      <div class="title">
        <h6>Filters</h6>
      </div>
      <div class="close">
        <button pButton type="button" icon="pi pi-times" (click)="mobilFilter = false"></button>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="card filterTab">
      <p-tabView [(activeIndex)]="activeIndex">
        <p-tabPanel header="State">
          <div class="filterBody">
            <div class="titleTable">
              <h6>FILTER BY</h6>
            </div>
            <div class="filterHeader">
              <div class="searchbar">
                <input pInputText type="text" placeholder="Search for State" [(ngModel)]="searchedStateName"
                  (input)="onSearchState($event)" class="search-input" />
                <div class="icon">
                  <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                </div>
              </div>
            </div>
            <div class="filterMainList">
              <div *ngFor="let state of statelist" class="filterList">
                <p-checkbox [value]="state" [(ngModel)]="selectedState" [binary]="false"
                  (onChange)="onStateSelect($event)"></p-checkbox>
                <label for="selectedAges">{{ state.name }}</label>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="City">
          <div class="filterBody">
            <div class="titleTable">
              <h6>FILTER BY</h6>
            </div>
            <div class="filterHeader">
              <div class="searchbar">
                <input pInputText type="text" placeholder="Search for City" [(ngModel)]="searchedCityName"
                  (input)="onSearchCity($event)" class="search-input" />
                <div class="icon">
                  <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                </div>
              </div>
            </div>
            <div class="filterMainList">
              <div *ngFor="let city of cityList" class="filterList">
                <p-checkbox [value]="city" [(ngModel)]="selectedCity" [binary]="false"
                  (onChange)="onCitySelect($event)"></p-checkbox>
                <label for="selectedAges">{{ city.name }}</label>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Category">
          <div class="filterBody">
            <div class="titleTable">
              <h6>FILTER BY</h6>
            </div>
            <div class="filterMainList">
              <div *ngFor="let category of categoryList" class="filterList">
                <p-checkbox [value]="category" [(ngModel)]="selectedCategories" [binary]="false"
                  (onChange)="onCategorySelect($event)"></p-checkbox>
                <label for="selectedAges">{{ category?.categoryName }}</label>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Academy">
          <div class="filterBody">
            <div class="titleTable">
              <h6>FILTER BY</h6>
            </div>
            <div class="filterMainList">
              <div *ngFor="let academy of academylist" class="filterList">
                <p-checkbox [value]="academy" [(ngModel)]="selectedAcademy" [binary]="false"
                  (onChange)="onAcademySelect($event)"></p-checkbox>
                <label for="selectedAges">{{ academy.name }}</label>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Year">
          <div class="filterBody">
            <div class="titleTable">
              <h6>FILTER BY</h6>
            </div>
            <div class="filterMainList">
              <div *ngFor="let year of yearlist" class="filterList">
                <p-checkbox [value]="year" [(ngModel)]="selectedFilterYear" [binary]="false"
                  (onChange)="onYearChange($event)"></p-checkbox>
                <label for="selectedAges">{{ year }}</label>
              </div>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="mainBtn">
      <div class="footerBtn">
        <button class="canelBtn" pButton type="button" label="CLEAR FILTER"
          (click)="clear(); mobilFilter = false"></button>
        <button class="applyBtn" pButton type="button" label="APPLY" (click)="mobilFilter = false"></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
<p-dialog id="shortingModal" [(visible)]="shortingModal"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="true"
  [draggable]="false" [resizable]="false" [closable]="false">
  <ng-template pTemplate="header">
    <div class="filterHeader">
      <div class="title">
        <h6>Sort</h6>
      </div>
      <div class="close">
        <button pButton type="button" icon="pi pi-times" (click)="shortingModal = false"></button>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <ul class="shortingList">
      <li>
        <label for="ingredient1" class="ml-2">
          Level: Low to High
        </label>
        <p-radioButton name="pizza" value="Cheese" inputId="ingredient1"></p-radioButton>
      </li>
      <li>
        <label for="ingredient2" class="ml-2">
          Level: High to Low
        </label>
        <p-radioButton name="pizza" value="Cheese" inputId="ingredient2"></p-radioButton>
      </li>
    </ul>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="mainBtn">
      <div class="footerBtn">
        <button class="canelBtn" pButton type="button" label="CLEAR FILTER"
          (click)="clear(); shortingModal = false"></button>
        <button class="applyBtn" pButton type="button" label="APPLY" (click)="shortingModal = false"></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
<p-dialog [closable]="true" [(visible)]="downloadModal" [modal]="true" [style]="{width: '416px'}"
    id="downloadModalPopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" [closable]="false" [position]="position">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div>
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>
        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>
        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog>
